import { component } from 'flightjs';

function ScrollToTopUI() {
    this.defaultAttrs({
        linkSelector: '[data-scroll-to-top-link]',
        activeClass: 'active'
    });

    this._scrollToTop = function() {
        window.scrollTo(0, 1);
        this._disableButton();
        this.select('linkSelector').blur();
    };

    this._toggleElement = function() {
        let scrollY = this.$window.scrollTop();

        if (scrollY > 100) {
            this._enableButton();
        } else {
            this._disableButton();
        }

        this.lastScrollY = scrollY;
    };

    this._enableButton = function() {
        this.select('linkSelector').attr('disabled', false);
        this.$node.addClass(this.attr.activeClass);
    };

    this._disableButton = function() {
        this.select('linkSelector').attr('disabled', true);
        this.$node.removeClass(this.attr.activeClass);
    };

    this.after('initialize', function() {
        let scrollEvent = 'scroll';

        this.throttledToggleElement = _.throttle(this._toggleElement, 50);

        this.lastScrollY = window.scrollY;
        this.$window = $(window);

        this.on(document, scrollEvent, this.throttledToggleElement.bind(this));

        this.on('click', {
            linkSelector: this._scrollToTop
        });
    });
}

export default component(ScrollToTopUI);
